module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Movimento Diário'
    }
  }), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', {
    staticClass: "col-md-7"
  }, [_vm._v("Movimento Diário")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "col-md-8 pull-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    ref: "caixaPesquisa",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar em todas as pastas...",
      "title": '<h5>Digite uma palavra e pressione Enter</h5>'
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisar()
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.pesquisa.length > 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "input-group-btn",
    attrs: {
      "title": '<h5>Limpar essa pesquisa</h5>'
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "white",
      "border-color": "#d2d6de",
      "border-width": "1px 0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.limparPesquisa()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.pesquisa,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "content ged"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "pastas"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.pastas),
      expression: "loading.pastas"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('tree', {
    ref: "tree",
    attrs: {
      "data": _vm.arvore,
      "options": _vm.opts,
      "filter": _vm.filter
    },
    on: {
      "node:selected": _vm.selecionaPasta
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;

        return _c('div', {
          staticClass: "node-container"
        }, [_c('div', {
          staticClass: "node-text"
        }, [_vm._v(_vm._s(node.text) + "\n                          "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm._.isEmpty(_vm._.find(_vm.usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))),
            expression: "_.isEmpty(_.find(usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))"
          }],
          staticClass: "edicao"
        }, [(node.data.renomear) ? _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.renomearPasta(node)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })]) : _vm._e(), _vm._v(" "), (node.data.excluir) ? _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.excluirPasta(node)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]) : _vm._e(), _vm._v(" "), (node.data.criar) ? _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.adicionarPasta(node)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })]) : _vm._e()])])])
      }
    }]),
    model: {
      value: (_vm.pastaSelecionada),
      callback: function($$v) {
        _vm.pastaSelecionada = $$v
      },
      expression: "pastaSelecionada"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "id": "conteudo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.arquivos),
      expression: "loading.arquivos"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostrarAdicionarDocumento),
      expression: "!mostrarAdicionarDocumento"
    }],
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [(_vm.modo === 'pesquisa') ? _c('span', [_vm._v("Resultado da pesquisa")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.pastaSelecionada) && _vm.modo === 'pasta') ? _c('span', [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v("  " + _vm._s(_vm.pastaSelecionada.data.text) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "contadorArqivos"
  }, [(_vm.arquivos.length > 0) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.arquivos.length) + " " + _vm._s(_vm.arquivos.length === 1 ? 'arquivo' : 'arquivos') + "\n                              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm.arquivosSelecionados.length > 0) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.arquivosSelecionados.length) + " " + _vm._s(_vm.arquivosSelecionados.length === 1 ? 'selecionado' : 'selecionados') + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm.arquivos.length > 0) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm._.find(_vm.usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))),
      expression: "_.isEmpty(_.find(usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))"
    }],
    staticClass: "indicadores-cb-inline"
  }, [_c('i', {
    class: (_vm.arquivosSelecionados.length !== _vm.arquivos.length ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.selecionarTodosArquivos
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.arquivosSelecionados.length !== _vm.arquivos.length ? '' : 'selecionado'
  }, [_vm._v("Selecionar tudo")])]) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm._.find(_vm.usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))),
      expression: "_.isEmpty(_.find(usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))"
    }],
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.arquivosSelecionados.length > 0) ? _c('span', [_c('g-button-ujarak', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.excluirArquivos($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Excluir")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm._.has(_vm.pastaSelecionada, 'data') && _vm._.has(_vm.pastaSelecionada.data, 'adicionar') && _vm.pastaSelecionada.data.adicionar === 1 && _vm.modo === 'pasta') ? _c('span', [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.mostrarAdicionarDocumento = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostrarAdicionarDocumento),
      expression: "!mostrarAdicionarDocumento"
    }],
    staticClass: "box-body"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.arquivos,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": _vm.modo === 'pasta' ? 'Sem arquivo nesta pasta!' : 'A pesquisa não retornou arquivos',
      "table-layout:": "",
      "fixed": ""
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "filtered": _vm.filtrarArquivos
    },
    scopedSlots: _vm._u([{
      key: "nome",
      fn: function(row) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm._.isEmpty(_vm._.find(_vm.usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))),
            expression: "_.isEmpty(_.find(usuarioLogado.permissoes, ['ds_nome', 'movimento-diario-somente-leitura']))"
          }],
          staticClass: "indicadores"
        }, [_c('i', {
          class: (_vm._.find(_vm.arquivosSelecionados, ['id', row.item.id]) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' selecao',
          staticStyle: {
            "margin-right": "20px"
          },
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.selecionarArquivo(row.item)
            }
          }
        })]), _vm._v(" "), _c('a', {
          staticClass: "ng-binding",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.downloadArquivo(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.item.ds_nome_arquivo))]), _vm._v(" "), (_vm._.has(row.item, 'pasta') && _vm.modo === 'pesquisa') ? _c('span', [_c('br'), _c('i', {
          staticClass: "fa fa-folder-o"
        }), _vm._v(" " + _vm._s(row.item.pasta.nome))]) : _vm._e()]
      }
    }, {
      key: "dt_criado",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm:ss")))]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarAdicionarDocumento),
      expression: "mostrarAdicionarDocumento"
    }],
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('upload-documento-movimento-diario', {
    attrs: {
      "documentTypes": '',
      "pasta": _vm.pastaSelecionada
    },
    on: {
      "mostrarQuadroAdicionaDocumento": function($event) {
        _vm.mostrarAdicionarDocumento = $event
      },
      "atualizarPasta": function($event) {
        return _vm.selecionaPasta($event)
      }
    }
  })], 1)])])])])])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e95e142!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/ged/MovimentoDiario.vue
// module id = 1978
// module chunks = 1